export default __webpack_public_path__ + "static/media/mealprep.c5cb6d29.png";